import React from 'react';

export default () => <div className='divider' />